// extracted by css-extract-rspack-plugin
export default {"player":"tZRj7j"};